import actionTypes from 'SRC/modules/redux/actionTypes'

export const setError = error => ({
  type: actionTypes.SET_ADD_AD_ERROR,
  payload: error
})
